import React, { useContext, useEffect, useState, useCallback } from 'react';
import { GetWithdrawHistory } from '../Api/GetWithdrawHistory';
import { Context } from '../Context/Context';
import { useLocation, useNavigate } from 'react-router-dom';
import { Flip, toast } from 'react-toastify';
import WithdrawDetailModal from './WithdrawDetailModal';

export default function WithdrawHistory() {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const [withdrawHistoryData, setWithdrawHistoryData] = useState([]);

    const {
        setLoad,
        setLoadColor,
        numberModal,
        sideBarOpen,
        setWithdrawDetailModal,
        setWithdrawDetailModalStatus
    } = useContext(Context);

    const handleWithdrawHistory = useCallback(async () => {
        setLoad(true);
        setLoadColor("#434343");

        const data = {
            username: JSON.parse(localStorage.getItem('userinfo'))?.username
        };

        const res = await GetWithdrawHistory(data);
        if (res) {
            if (res.data.status) {
                setWithdrawHistoryData(res.data.data);
            } else {
                toast.error(res.data.message, {
                    position: "top-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    transition: Flip,
                });
            }
        }

        setLoad(false);
    }, [setLoad, setLoadColor]);

    useEffect(() => {
        if (pathname === "/withdraw/withdrawHistory" && !numberModal && !sideBarOpen) {
            handleWithdrawHistory();
        }
    }, [pathname, handleWithdrawHistory, numberModal, sideBarOpen]);

    const handleWithdrawDetail = (ele) => {
        setWithdrawDetailModal(ele);
        setWithdrawDetailModalStatus(true);
    };

    return (
        <>
            <div className='depositContainer'>
                <div className="wrapper" style={{ marginTop: "0px" }}>
                    <div className="section">
                        <div className="top_navbar" style={{ height: "60px" }}>
                            <div className="hamburger">
                                <button className='back_btn' onClick={() => navigate("/game")} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
                                    <i className="fa-solid fa-chevron-left"></i>
                                </button>
                            </div>
                            <div className='gameName'>Withdraw History</div>
                        </div>
                    </div>
                </div>

                <div className="Tablecontainer" style={{ marginTop: "60px", width: "100%" }}>
                    <table>
                        <thead>
                            <tr>
                                <th>Transaction ID</th>
                                <th>Amount</th>
                                <th>Remark</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {withdrawHistoryData?.map((ele, i) => (
                                <tr key={i}>
                                    <td onClick={() => handleWithdrawDetail(ele)}>{ele?.transaction_id}</td>
                                    <td>{ele?.withdraw_amount}</td>
                                    <td>{ele?.remarks}</td>
                                    <td>
                                        {ele?.withdraw_status === 0 && (
                                            <button type="button" className="btn btn-warning btnyellow-custom">Pending</button>
                                        )}
                                        {ele?.withdraw_status === 1 && (
                                            <button type="button" className="btn btn-success btngreen-success-custom">Success</button>
                                        )}
                                        {ele?.withdraw_status === 2 && (
                                            <button type="button" className="btn btn-danger btnred-danger-custom">Rejected</button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <WithdrawDetailModal />
        </>
    );
}
